import { Recipe, ItemType } from '../types';

export const RECIPES: Recipe[] = [
  {
    id: ItemType.Spear,
    name: 'Spear',
    woodCost: 5,
    coinCost: 3,
    description: 'Throw to boop intruders! (Press E)',
  },
  {
    id: ItemType.SuperAxe,
    name: 'Super Axe',
    woodCost: 8,
    coinCost: 10,
    description: 'Chop trees in 1 hit instead of 3!',
  },
];
